import { c as _c } from "react/compiler-runtime";
import { delay } from 'betterplace-utils';
import analytics, { convertCentsToEuro, getDonationFormType } from 'product-analytics';
import { useCallback } from 'react';
import type { RedirectHandler } from './types';
import type { DonationFormValues } from '@/donationForm/types';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
import { usePaymentMethodsToRender } from '@/donationPages/_dependencies/NativePaymentMethods';
import { useRouter } from 'next/navigation';
import type { PaymentMethods } from 'api-graphql-types';
function useTrackDonationCompleted() {
  const $ = _c(6);
  const {
    receiverType,
    receiverId,
    channel,
    showCodonation
  } = useDonationFormConfig();
  const {
    paymentMethodsToRender
  } = usePaymentMethodsToRender();
  let t0;
  if ($[0] !== channel || $[1] !== paymentMethodsToRender || $[2] !== receiverId || $[3] !== receiverType || $[4] !== showCodonation) {
    t0 = (redirectTo, donationId, t1) => {
      const {
        amount_cents: amountCents,
        interval,
        payment_method: paymentMethod,
        codonation_cents: codonationCents,
        show_amount: showAmount,
        show_user: showUser,
        display_name: displayName,
        receipt_desired: receiptDesired,
        newsletter,
        message,
        import_data_from_psp
      } = t1;
      analytics.donationCompleted({
        donation_amount: convertCentsToEuro(amountCents),
        recurring_donation: interval,
        payment_method: paymentMethod,
        codonation_amount: convertCentsToEuro(codonationCents),
        show_amount_selected: showAmount,
        show_name_selected: !!(showUser || displayName),
        donation_receipt_requested: receiptDesired,
        platform_newsletter_selected: newsletter,
        comment_added: !!message,
        id: receiverId,
        receiver_type: receiverType,
        donation_form_type: getDonationFormType({
          channel,
          receiverType,
          receiverId,
          showCodonation
        }),
        postdonation_redirect_url: redirectTo,
        donation_id: donationId,
        available_payment_methods: paymentMethodsToRender as PaymentMethods[],
        data_imported: import_data_from_psp
      });
    };
    $[0] = channel;
    $[1] = paymentMethodsToRender;
    $[2] = receiverId;
    $[3] = receiverType;
    $[4] = showCodonation;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const trackDonationCompleted = t0;
  return trackDonationCompleted;
}

/**
 * A hook returning a RedirectHandler
 * @returns A referentially stable redirect handler that tracks the donation completed event and redirects the user to the given URL.
 */
function useRedirectHandler() {
  const $ = _c(3);
  const router = useRouter();
  const trackDonationCompleted = useTrackDonationCompleted();
  let t0;
  if ($[0] !== router || $[1] !== trackDonationCompleted) {
    t0 = async (redirectTo, donationId, values) => {
      trackDonationCompleted(redirectTo, donationId, values);
      return await delay(33, () => router.replace(redirectTo));
    };
    $[0] = router;
    $[1] = trackDonationCompleted;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const redirectHandler = t0;
  return redirectHandler;
}
export default useRedirectHandler;